/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/resources/ts/main.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/@biotope/resource-loader/lib/index.esm.js":
/*!****************************************************************!*\
  !*** ./node_modules/@biotope/resource-loader/lib/index.esm.js ***!
  \****************************************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceLoader = void 0;
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
} }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"])
    return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r))
    return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
var EVENTS = {
    RESOURCE_LOADED: 'RESOURCE_LOADED',
    COMPONENT_READY: 'COMPONENT_READY'
};
var getResourceElements = function getResourceElements() {
    var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    return [].slice.call(container.querySelectorAll('[data-resources]'));
};
var pipe = function pipe() {
    for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
        fns[_key] = arguments[_key];
    }
    return function (x) {
        return fns.reduce(function (v, f) {
            return f(v);
        }, x);
    };
};
var _curry = function curry(fn) {
    return function () {
        for (var _len2 = arguments.length, xs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            xs[_key2] = arguments[_key2];
        }
        if (xs.length === 0) {
            throw Error('EMPTY INVOCATION');
        }
        if (xs.length >= fn.length) {
            return fn.apply(void 0, xs);
        }
        return _curry(fn.bind.apply(fn, [null].concat(xs)));
    };
};
var defaultTo = function defaultTo(def, check) {
    return check || def;
};
var defaultTo$1 = _curry(defaultTo);
var prop = function prop(key, obj) {
    return obj[key];
};
var prop$1 = _curry(prop);
var getDataResourceFromElement = pipe(defaultTo$1(document.createElement('div')), prop$1('dataset'), prop$1('resources'), defaultTo$1(''));
var getComponentQueueFromElement = function getComponentQueueFromElement() {
    var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.createElement('div');
    var dataResources = getDataResourceFromElement(element);
    var definitions = eval(dataResources) || [];
    return definitions.map(function (d) {
        return Object.assign({}, d, {
            element: element
        });
    });
};
var unnest = function unnest(arr) {
    return [].concat.apply([], arr);
};
var getContentDefinitionsFromDOM = function getContentDefinitionsFromDOM() {
    var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    var domResources = getResourceElements(container);
    return unnest(domResources.map(getComponentQueueFromElement));
};
var unique = function unique(arr) {
    return arr.filter(function (value, index, self) {
        return self.indexOf(value) === index;
    });
};
var mergeResources = function mergeResources() {
    var resources = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return resources.reduce(function (aggregated, current) {
        if (aggregated.map(function (r) {
            return r.path;
        }).indexOf(current.path) !== -1) {
            return aggregated;
        }
        return [].concat(_toConsumableArray(aggregated), [Object.assign({}, current, {
                dependencyPaths: unique(unnest(resources.filter(function (r) {
                    return r.path === current.path;
                }).map(function (r) {
                    return r.dependencyPaths || [];
                }))),
                elements: unique(unnest(resources.filter(function (r) {
                    return r.path === current.path;
                }).map(function (r) {
                    return r.elements || [];
                })))
            })]);
    }, []);
};
var resolveBaseWith = function resolveBaseWith(baseMap, base) {
    if (!(base.substring(0, 2) === '##')) {
        return base;
    }
    return baseMap[base] || '';
};
var resolveBaseWith$1 = _curry(resolveBaseWith);
var isAbsolute = function isAbsolute(path) {
    return new RegExp('^(?:[a-z]+:)?//', 'i').test(path);
};
var isRootPath = function isRootPath(path) {
    return path.indexOf('/') === 0 && path.indexOf('//') !== 0;
};
var getTrailingSlashesRegex = function getTrailingSlashesRegex() {
    return /\/?$/;
};
var getLeadingSlashesRegex = function getLeadingSlashesRegex() {
    return /^\/?/;
};
var replace = function replace(selector, newValue, target) {
    return target.replace(selector, newValue);
};
var replace$1 = _curry(replace);
var ensureTrailingSlash = replace$1(getTrailingSlashesRegex(), '/');
var ensureNoLeadingSlash = replace$1(getLeadingSlashesRegex(), '');
var identity = function identity(el) {
    return el;
};
var concat = function concat(t1, t2) {
    return t1 + t2;
};
var concat$1 = _curry(concat);
var always = function always() {
    return true;
};
var max = function max(a, b) {
    return b > a ? b : a;
};
var _arity = function _arity(n, fn) {
    switch (n) {
        case 0:
            return function () {
                return fn.apply(this, arguments);
            };
        case 1:
            return function (a0) {
                return fn.apply(this, arguments);
            };
        case 2:
            return function (a0, a1) {
                return fn.apply(this, arguments);
            };
        case 3:
            return function (a0, a1, a2) {
                return fn.apply(this, arguments);
            };
        case 4:
            return function (a0, a1, a2, a3) {
                return fn.apply(this, arguments);
            };
        case 5:
            return function (a0, a1, a2, a3, a4) {
                return fn.apply(this, arguments);
            };
        case 6:
            return function (a0, a1, a2, a3, a4, a5) {
                return fn.apply(this, arguments);
            };
        case 7:
            return function (a0, a1, a2, a3, a4, a5, a6) {
                return fn.apply(this, arguments);
            };
        case 8:
            return function (a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.apply(this, arguments);
            };
        case 9:
            return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.apply(this, arguments);
            };
        case 10:
            return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.apply(this, arguments);
            };
        default:
            throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
    }
};
var cond = function cond(pairs) {
    var arity = pairs.map(function (pair) {
        return pair[0].length;
    }).reduce(max, 0);
    return _arity(arity, function () {
        var idx = 0;
        while (idx < pairs.length) {
            if (pairs[idx][0].apply(this, arguments)) {
                return pairs[idx][1].apply(this, arguments);
            }
            idx += 1;
        }
    });
};
var cond$1 = _curry(cond);
var isHtmlFilePath = function isHtmlFilePath(path) {
    return /^(ht|f)tp(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&amp;%\$#_]*)?\.html([a-zA-Z0-9\-\.\?\!\,\'\/\\\+&amp;%\$#_]*)?$/gm.test(path);
};
var shift = function shift(arr) {
    var clone = _toConsumableArray(arr);
    clone.shift();
    return clone;
};
var ensureNoHtmlFile = function ensureNoHtmlFile(path) {
    return isHtmlFilePath(path) ? shift(path.split('/').reverse()).reverse().join('/') : path;
};
var defaultToEmptyString = defaultTo$1('');
var ensureAbsolutePath = function ensureAbsolutePath(location) {
    return cond$1([[isAbsolute, identity], [isRootPath, pipe(ensureNoLeadingSlash, concat$1(ensureTrailingSlash(location.origin)))], [always, pipe(ensureNoLeadingSlash, concat$1(ensureTrailingSlash(ensureNoHtmlFile(location.href))))]]);
};
var createEnsureAbsolutePath = function createEnsureAbsolutePath(location) {
    return pipe(defaultToEmptyString, ensureAbsolutePath(location));
};
var isRelative = function isRelative(path) {
    return !isAbsolute(path);
};
var normalizePath = function normalizePath() {
    var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var resource = arguments.length > 1 ? arguments[1] : undefined;
    var options = arguments.length > 2 ? arguments[2] : undefined;
    if (resource && options && isRelative(path)) {
        if (resource.base) {
            var resolveBase = resolveBaseWith$1(options.baseMap);
            var _ensureAbsolutePath = createEnsureAbsolutePath(window.location);
            return _ensureAbsolutePath(ensureTrailingSlash(resolveBase(resource.base)) + path);
        }
        else if (options.base) {
            var _ensureAbsolutePath2 = createEnsureAbsolutePath(window.location);
            if (isRootPath(path)) {
                return _ensureAbsolutePath2(path);
            }
            return _ensureAbsolutePath2(ensureTrailingSlash(options.base) + path);
        }
    }
    return path;
};
var toResources = function toResources(options, definition) {
    if (!definition) {
        return [];
    }
    var pathResources = definition.paths.map(function (path) {
        return {
            path: normalizePath(path, definition, options),
            dependencyPaths: (definition.dependsOn ? definition.dependsOn : []).map(function (p) {
                return normalizePath(p, definition, options);
            }),
            elements: [definition.element]
        };
    });
    var dependencyResources = (definition.dependsOn ? definition.dependsOn : []).map(function (path) {
        return {
            path: normalizePath(path, definition, options),
            dependencyPaths: [],
            elements: [definition.element]
        };
    });
    return [].concat(_toConsumableArray(pathResources), _toConsumableArray(dependencyResources));
};
var toResources$1 = _curry(toResources);
var getResourcesFromContainer = function getResourcesFromContainer(options, container) {
    var componentDefinitions = getContentDefinitionsFromDOM(container);
    return mergeResources(unnest(componentDefinitions.map(toResources$1(options))));
};
var getResourcesFromContainer$1 = _curry(getResourcesFromContainer);
var loadResource = function loadResource(resource) {
    return fetch(resource.path).then(function (response) {
        var e = new CustomEvent(EVENTS.RESOURCE_LOADED, {
            detail: {
                resource: resource,
                response: response
            }
        });
        document.dispatchEvent(e);
    });
};
var loadResources = function loadResources(resources) {
    return resources.map(loadResource);
};
var getResourceByPath = function getResourceByPath(resources, path) {
    return resources.find(function (r) {
        return r.path === path;
    });
};
// ⚠️ TODO: does not check circular dependencies!!!
var checkIfResolvable = function checkIfResolvable() {
    var resources = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return resources.every(function (resource) {
        return resource.dependencyPaths.every(function (path) {
            return !!getResourceByPath(resources, path);
        });
    });
};
var getReadyResources = function getReadyResources() {
    var resourcesToCheck = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var loadedResources = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return resourcesToCheck.filter(function (resource) {
        return resource.dependencyPaths.every(function (path) {
            return loadedResources.some(function (res) {
                return res.path === path;
            });
        });
    });
};
var isCss = function isCss(options) {
    return options.resource.path.indexOf('.css') > -1;
};
var onCssLoaded = function onCssLoaded(options) {
    var style = document.createElement('link');
    style.rel = 'stylesheet';
    style.href = options.resource.path;
    document.body.append(style);
};
var cssHandler = {
    match: isCss,
    handle: onCssLoaded
};
var isJs = function isJs(options) {
    return options.resource.path.indexOf('.js') > -1;
};
var onJsLoaded = function onJsLoaded(options) {
    var script = document.createElement('script');
    script.src = options.resource.path;
    script.async = true;
    document.body.append(script);
};
var jsHandler = {
    match: isJs,
    handle: onJsLoaded
};
var isEmpty = function isEmpty(test) {
    return test.length === 0;
};
function _Set() {
    /* globals Set */
    this._nativeSet = typeof Set === 'function' ? new Set() : null;
    this._items = {};
}
// until we figure out why jsdoc chokes on this
// @param item The item to add to the Set
// @returns {boolean} true if the item did not exist prior, otherwise false
//
_Set.prototype.add = function (item) {
    return !hasOrAdd(item, true, this);
};
//
// @param item The item to check for existence in the Set
// @returns {boolean} true if the item exists in the Set, otherwise false
//
_Set.prototype.has = function (item) {
    return hasOrAdd(item, false, this);
};
//
// Combines the logic for checking whether an item is a member of the set and
// for adding a new item to the set.
//
// @param item       The item to check or add to the Set instance.
// @param shouldAdd  If true, the item will be added to the set if it doesn't
//                   already exist.
// @param set        The set instance to check or add to.
// @return {boolean} true if the item already existed, otherwise false.
//
function hasOrAdd(item, shouldAdd, set) {
    var type = _typeof(item);
    switch (type) {
        case 'undefined':
            if (set._items[type]) {
                return true;
            }
            else {
                if (shouldAdd) {
                    set._items[type] = true;
                }
                return false;
            }
        case 'object':
            if (item === null) {
                if (!set._items['null']) {
                    if (shouldAdd) {
                        set._items['null'] = true;
                    }
                    return false;
                }
                return true;
            }
        /* falls through */
        default:
            // reduce the search size of heterogeneous sets by creating buckets
            // for each type.
            type = Object.prototype.toString.call(item);
            if (!(type in set._items)) {
                if (shouldAdd) {
                    set._items[type] = [item];
                }
                return false;
            }
            // scan through all previously applied items
            if (set._items[type].indexOf(item) === -1) {
                if (shouldAdd) {
                    set._items[type].push(item);
                }
                return false;
            }
            return true;
    }
}
var difference = function difference(first, second) {
    var out = [];
    var idx = 0;
    var firstLen = first.length;
    var secondLen = second.length;
    var toFilterOut = new _Set();
    for (var i = 0; i < secondLen; i++) {
        toFilterOut.add(second[i]);
    }
    while (idx < firstLen) {
        if (toFilterOut.add(first[idx])) {
            out[out.length] = first[idx];
        }
        idx += 1;
    }
    return out;
};
var difference$1 = _curry(difference);
var remove = function remove(start, deleteCount, arr) {
    return _toConsumableArray(arr).splice(start, deleteCount);
};
var remove$1 = _curry(remove);
var ResourceLoader = /*#__PURE__*/ function () {
    function ResourceLoader(options) {
        this.options = null;
        this.pendingResources = [];
        this.loadedResources = [];
        this.defaultOptions = {
            readyEvent: 'resourcesReady',
            handler: [cssHandler, jsHandler]
        };
        this.options = Object.assign({
            container: this.defaultContainer
        }, this.defaultOptions, options);
        this.bindEvents();
        this.init(this.options);
    }
    var _proto = ResourceLoader.prototype;
    _proto.init = function init(options) {
        this.prepareQueue(options);
        loadResources(this.pendingResources);
    };
    _proto.prepareQueue = function prepareQueue(options) {
        this.waitingResources = _toConsumableArray(getResourcesFromContainer$1(options, options.container));
        this.waitingResources = this.cleanLoadedFromWaiting();
        checkIfResolvable(this.waitingResources);
        this.pendingResources = [].concat(_toConsumableArray(this.pendingResources), _toConsumableArray(getReadyResources(this.waitingResources, this.loadedResources)));
        this.waitingResources = difference$1(this.waitingResources, this.pendingResources);
    };
    _proto.cleanLoadedFromWaiting = function cleanLoadedFromWaiting() {
        var _this = this;
        return this.waitingResources.filter(function (resource) {
            return !_this.loadedResources.some(function (loaded) {
                return loaded.path === resource.path;
            });
        });
    };
    _proto.getStatus = function getStatus() {
        return {
            waiting: this.waitingResources,
            pending: this.pendingResources,
            loaded: this.loadedResources
        };
    };
    _proto.bindEvents = function bindEvents() {
        document.addEventListener(EVENTS.RESOURCE_LOADED, this.onResourceLoaded.bind(this));
        document.addEventListener(this.options.readyEvent, this.onReady.bind(this));
    };
    _proto.onResourceLoaded = function onResourceLoaded(event) {
        var resource = event.detail.resource;
        var handler = this.options.handler.map(function (handler) {
            return [handler.match, handler.handle];
        });
        cond$1(handler)(event.detail);
        this.loadedResources.push(resource);
        var readyForLoad = getReadyResources(this.waitingResources, this.loadedResources);
        this.pendingResources = [].concat(_toConsumableArray(remove$1(this.pendingResources.indexOf(resource), 1, this.pendingResources)), _toConsumableArray(readyForLoad));
        this.waitingResources = difference$1(this.waitingResources, this.pendingResources);
        loadResources(readyForLoad);
        if (isEmpty(this.waitingResources) && isEmpty(this.pendingResources)) {
            var _event = new CustomEvent(this.options.readyEvent);
            document.dispatchEvent(_event);
        }
    };
    _proto.onReady = function onReady() { };
    _proto.update = function update() {
        this.init(this.options);
    };
    _createClass(ResourceLoader, [{
            key: "defaultContainer",
            get: function get() {
                return document.querySelector('body');
            }
        }]);
    return ResourceLoader;
}();
exports.ResourceLoader = ResourceLoader;
exports.default = ResourceLoader;


/***/ }),

/***/ "./node_modules/vm-browserify/index.js":
/*!*********************************************!*\
  !*** ./node_modules/vm-browserify/index.js ***!
  \*********************************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports) {

function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
var indexOf = function indexOf(xs, item) {
    if (xs.indexOf)
        return xs.indexOf(item);
    else
        for (var i = 0; i < xs.length; i++) {
            if (xs[i] === item)
                return i;
        }
    return -1;
};
var Object_keys = function Object_keys(obj) {
    if (Object.keys)
        return Object.keys(obj);
    else {
        var res = [];
        for (var key in obj)
            res.push(key);
        return res;
    }
};
var forEach = function forEach(xs, fn) {
    if (xs.forEach)
        return xs.forEach(fn);
    else
        for (var i = 0; i < xs.length; i++) {
            fn(xs[i], i, xs);
        }
};
var defineProp = function () {
    try {
        Object.defineProperty({}, '_', {});
        return function (obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    }
    catch (e) {
        return function (obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = ['Array', 'Boolean', 'Date', 'Error', 'EvalError', 'Function', 'Infinity', 'JSON', 'Math', 'NaN', 'Number', 'Object', 'RangeError', 'ReferenceError', 'RegExp', 'String', 'SyntaxError', 'TypeError', 'URIError', 'decodeURI', 'decodeURIComponent', 'encodeURI', 'encodeURIComponent', 'escape', 'eval', 'isFinite', 'isNaN', 'parseFloat', 'parseInt', 'undefined', 'unescape'];
function Context() { }
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script))
        return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function (context) {
    if (!(context instanceof Context)) {
        throw new TypeError("needs a 'context' argument.");
    }
    var iframe = document.createElement('iframe');
    if (!iframe.style)
        iframe.style = {};
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    forEach(Object_keys(context), function (key) {
        win[key] = context[key];
    });
    forEach(globals, function (key) {
        if (context[key]) {
            win[key] = context[key];
        }
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function (key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) {
            context[key] = win[key];
        }
    });
    forEach(globals, function (key) {
        if (!(key in context)) {
            defineProp(context, key, win[key]);
        }
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function () {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function (context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) {
        forEach(Object_keys(ctx), function (key) {
            context[key] = ctx[key];
        });
    }
    return res;
};
forEach(Object_keys(Script.prototype), function (name) {
    exports[name] = Script[name] = function (code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function (context) {
    return context instanceof Context;
};
exports.createScript = function (code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function (context) {
    var copy = new Context();
    if (_typeof(context) === 'object') {
        forEach(Object_keys(context), function (key) {
            copy[key] = context[key];
        });
    }
    return copy;
};


/***/ }),

/***/ "./src/resources/ts/main.ts":
/*!**********************************!*\
  !*** ./src/resources/ts/main.ts ***!
  \**********************************/
/*! no static exports found */
/*! ModuleConcatenation bailout: Module is not an ECMAScript module */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var index_esm_1 = __webpack_require__(/*! @biotope/resource-loader/lib/index.esm */ "./node_modules/@biotope/resource-loader/lib/index.esm.js");
var vm = __webpack_require__(/*! vm */ "./node_modules/vm-browserify/index.js");
{
    var init = function () {
        var elementsWithDataInit = [].slice.call(document.querySelectorAll('[data-init]'));
        elementsWithDataInit.forEach(function (element) {
            var initFunction = vm.runInThisContext(element.dataset.init);
            initFunction(element);
        });
    };
    var setupResourceLoader = function (callback) {
        var cssHandler = {
            match: function (options) { return options.resource.path.indexOf('.css') > -1; },
            handle: function (options) {
                var style = document.createElement('link');
                style.rel = 'stylesheet';
                style.href = options.resource.path;
                document.body.appendChild(style);
            }
        };
        var jsHandler = {
            match: function (options) { return options.resource.path.indexOf('.js') > -1; },
            handle: function (options) {
                var script = document.createElement('script');
                script.src = options.resource.path;
                script.async = true;
                document.body.appendChild(script);
                script.onload = function () { return callback(); };
            }
        };
        return new index_esm_1.default({
            base: biotope.configuration.get('data.staticResourcesBase'),
            baseMap: {
                '##content': biotope.configuration.get('data.staticResourcesContentRepoBase')
            },
            handler: [
                cssHandler,
                jsHandler
            ]
        });
    };
    setupResourceLoader(init);
}
;


/***/ })

/******/ });
//# sourceMappingURL=main.js.map